import React from "react";
import { useTheme, withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
//import "react-day-picker/lib/style.css";
import "fontsource-muli";
import CustomText, { getFontSize, getFontWeight } from "../CustomText";
import Color from "../../../utils/Color";
import CustomTextInput from "../CustomTextInput";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const CustomTitleTextInput = ({
  classes,
  title,
  text,
  value,
  handleChangeValue,
  matchesSM = false,
  isVisibleCurrency = true,
  isVisibleDescriptionText = false,
  type = "number",
  id = "number",
  smTitleSize = 12,
  smTextInputSize = 12,
  lgTitleSize = 12,
  lgTextInputSize,
  rootStyle,
  errorRootStyle,
  titleTextStyle,
  disabled = false,
  startAdornment,
  endAdornment,
  onBlur,
  ...props
}) => {
  const theme = useTheme();
  const matchesXS = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Grid container direction={"column"}>
      <Grid
        item
        xs={12}
        sm={smTitleSize ? smTitleSize : 8}
        lg={lgTitleSize ? lgTitleSize : 8}
      >
        <CustomText design={titleTextStyle? titleTextStyle : classes.titleTextStyle}>{title}</CustomText>
      </Grid>
      <Grid
        item
        xs={12}
        sm={smTextInputSize ? smTextInputSize : 4}
        lg={lgTextInputSize ? lgTextInputSize : 4}
        style={{
          marginTop: matchesXS ? 12 : 0
        }}
      >
        <Grid container direction={"row"} alignItems={"center"}>
          {isVisibleCurrency ? (
            <Grid item>
              <CustomText design={classes.contentTextStyle}>SGD</CustomText>
            </Grid>
          ) : (
            false
          )}
          <Grid item>
            <CustomTextInput
              id={id}
              rootStyle={rootStyle ? rootStyle : classes.textInputStyle}
              errorRootStyle={errorRootStyle ? errorRootStyle : null}
              inputStyle={classes.contentTextStyle}
              type={type}
              value={value}
              onChange={handleChangeValue}
              disabled={disabled}
              startAdornment={startAdornment}
              endAdornment={endAdornment}
              onBlur={onBlur}
              {...props}
            />
          </Grid>
          {isVisibleDescriptionText ? (
            <Grid item>
              <CustomText design={classes.contentTextStyle}>
                (in multiples of SGD500)
              </CustomText>
            </Grid>
          ) : (
            false
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

const styles = theme => ({
  titleTextStyle: {
    color: Color.primaryTextColor
  },
  contentTextStyle: {
    color: Color.primaryTextColor,
    ...getFontWeight("normal"),
    "&[type=number]": {
      "-moz-appearance": "textfield"
    },
    "&::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0
    },
    "&::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0
    }
  },
  textInputStyle: {
    width: 120,
    height: 35,
    marginLeft: 5,
    marginRight: 5
  }
});

export default withStyles(styles, { withTheme: true })(CustomTitleTextInput);
